import React from 'react'

const Loading = () => {
  return (
    <>
         <div style={{width:"100%",height:"100vh",display:"flex",justifyContent:"center",alignItems:"center",zIndex:"9999"}}>
           <div style={{margin:"auto"}}>
             <div className="text-center mx-auto">
               <div className="spinner-border text-white fs-3" role="status">
                   {/* <span class="sr-only">Loading...</span> */}
               </div>
               <h3 style={{color:"white"}}>Please Wait...</h3>
             </div>
           </div>
         </div>
      </>
  )
}

export default Loading
